'use strict'

/**
 * Хранилище для плейлиста
 */

import * as types from '@/store/types'

const state = {
  tickets: [],
  clientsQueue: null,
  size: 4,
  states: []
}

const mutations = {
  [types.BOARD.tickets.set]: (store, model) => {
    store.tickets = model.getClients()
  },
  [types.BOARD.clients.queue.set]: (store, model) => {
    store.clientsQueue = model
  },
  [types.BOARD.size.set]: (store, value) => {
    store.size = value
  },
  [types.BOARD.states.set]: (store, states) => {
    store.states = states
  }
}

const actions = {
  [types.BOARD.tickets.set] (context, model) {
    context.commit(types.BOARD.tickets.set, model)
  },
  [types.BOARD.clients.queue.set] (context, model) {
    context.commit(types.BOARD.clients.queue.set, model)
  },
  [types.BOARD.size.set] (context, value) {
    context.commit(types.BOARD.size.set, value)
  },
  [types.BOARD.states.set] (context, states) {
    context.commit(types.BOARD.states.set, states)
  }
}

export default {
  state,
  mutations,
  actions
}
